import { render } from "./AppFooter.vue?vue&type=template&id=9c992dc2"
const script = {}

import exportComponent from "C:\\Users\\Denisse\\node_projects\\app-pages-v2\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__